import React, { useEffect } from 'react'
import config from '../../../configuration/config.json'
import logo from "../../../images/ToppanSecurity.svg";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { tokenRequestPayload, logoutUrl } from '../../../auth/authProvider';


export default () => {
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get("code");
    const sessiontimeoutmilliseconds = 1200000;

    useEffect(() => {

       
        if ((code == null || code == undefined || code == '') && sessionStorage.getItem('auth_code') == undefined) {
            navigate("/");
            return;
        }

       
        if (sessionStorage.getItem('auth_code') == undefined) {
            sessionStorage.setItem('auth_code', code);
            localStorage.setItem('mdmsstate','logged');
            localStorage.setItem('loggedtime', new Date());
            setTimeout(endSession,sessiontimeoutmilliseconds);
            fetchAccessToken();
        } else {
            var loggedTime = new Date(localStorage.getItem('loggedtime'));
            var currentTime = new Date();
            var expectedmilliseconds = loggedTime.setMilliseconds(sessiontimeoutmilliseconds);
            var currentmilliseconds = currentTime.setMilliseconds(0);
            if(loggedTime.setMilliseconds(sessiontimeoutmilliseconds) < currentTime.setMilliseconds(0)){
                endSession();
            }
            setTimeout(endSession,expectedmilliseconds-currentmilliseconds);
            fetchUserInfo();
        }
    }, [])


    async function fetchAccessToken() {

        const response = await axios.request({
            method: 'POST',
            url: config.operatorportal.apibaseurl + 'document/configurations/token',
            headers: { "content-type": "application/json" },
            responseType: 'application/json',
            data: JSON.stringify(tokenRequestPayload(sessionStorage.getItem('auth_code')))
        });
        sessionStorage.removeItem('pkce_code_verifier');
        if (response.status == 200) {
            let apiResponse = JSON.parse(response.data);
            if (apiResponse.status != 200) {
               endSession();
            } else {
                sessionStorage.setItem('access_token', apiResponse.message.access_token);
                sessionStorage.setItem('id_token', apiResponse.message.id_token);
                sessionStorage.setItem('expires_in', apiResponse.message.expires_in);
                await fetchUserInfo();
            }
        } else {

        }
    }


    async function fetchUserInfo() {

        const response = await axios.request({
            method: 'GET',
            url: config.operatorportal.apibaseurl + 'document/configurations/userinfo',
            headers: { "content-type": "application/json", Authorization: `Bearer ${sessionStorage.getItem('access_token')}` },
            responseType: 'application/json'
        });

        if (response.status == 200) {
            let apiResponse = JSON.parse(response.data);

            if (apiResponse.status != 200) {
                endSession();
            } else {
                sessionStorage.setItem('user_name', apiResponse.message.user_name)
                document.getElementById('spanuserlogged').innerHTML = apiResponse.message.user_name + '!';
            }
        } else {

        }
    }

    


    return (
        <div>
            <nav class="navbar navbar-expand-lg navbar-light App-header">
                <div class="container-fluid">
                    <a class="navbar-brand" href="#"><img src={logo} width="104" height="43"  alt="Logo"></img>
                    </a>
                    <span class='text-black'>goID™ Issuance System Portal</span>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse justify-content-end navbarHeader" id="navbarNav">
                        <ul class="navbar-nav navbar-right">
                            {/*<li class="nav-item">*/}
                            {/*    <a class="nav-link text-white" aria-current="page" href="/issuerweb/landing/home">Home</a>*/}
                            {/*</li>*/}
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle text-black" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Life Cycle Mgr
                                </a>
                                <ul class="dropdown-menu hidNavDropdown" aria-labelledby="navbarDropdown">
                                    <li><a class="dropdown-item" href="/issuance/enrollment-form">Enrollment</a></li>
                                    <li><a class="dropdown-item" href="/documents/status">Status</a></li>
                                    <li><a class="dropdown-item" href="/documents/label-language">Label Local Language</a></li>
                                    <li><a class="dropdown-item" href="/documents/templates">Templates</a></li>

                                </ul>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link text-black" onClick={endSession} href="#">Logout</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

        </div>
    )
  


    async function endSession() {

        if(localStorage.getItem('mdmsstate') == null || localStorage.getItem('mdmsstate') == undefined
        || localStorage.getItem('mdmsstate') == 'login'){
            navigate('/');
        }else{
        const url = await logoutUrl();
        // the post-logout redirect may land on a protected page; clear the session so the header sends the user to login
        localStorage.setItem('mdmsstate', 'login');
        sessionStorage.clear();
        window.location = url;
        }
    }


}